import axios from "axios";

export default {
  namespaced: true,
  state: {
    logo: null,
    user: null,
    node: null,
    stats_tree: null,
    code_sucess: null,
    password_sucess: null,
  },
  getters: {
    userInfo: (state) => state.user,
    isComplete: (state) => state.node,
    statsTree: (state) => state.stats_tree,
  },
  mutations: {
    addFile(state, image) {
      state.logo = image;
    },
    setUser(state, user) {
      state.user = user;
    },
    setGroup(state, group) {
      state.group = group;
    },
    codeSucess(state, data) {
      state.code_sucess = data;
    },
    passwordSucess(state, data) {
      state.password_sucess = data;
    },
    setNodeComplete(state, data) {
      state.node = data;
    },
    stats(state, data) {
      state.stats_tree = data;
    },
  },
  actions: {
    uploadLogo({ commit, rootState }, image) {
      if (image.target.files.length === 0) {
        return null;
      }

      // console.log(image.target.files[0])
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("file", image.target.files[0]);
        axios
          .post(`${rootState.api}User/UploadLogo`, formData, {
            "Content-Type": "multipart/form-data",
          })
          .then((resp) => {
            commit("addFile", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateUser({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/Update`, data)
          .then((resp) => {
            commit("setUser", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getUserInfo({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}User/getUserInfo`)
          .then((resp) => {
            localStorage.setItem(
              "hasMainOrganization",
              `${resp.data.hasMainOrganization}`
            );
            commit("setUser", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    searchGroups({ commit, rootState }, search) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}User/SearchGroups?q=${search}`)
          .then((resp) => {
            commit("setGroup", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendCode({ commit, rootState }, login) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/SendRecoveryCode?login=${login}`)
          .then((resp) => {
            commit("codeSucess", resp.data.success);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkCode({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}User/CheckRecoveryCode?login=${data.login}&code=${data.code}`
          )
          .then((resp) => {
            commit("codeSucess", resp.data.success);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    changePassword({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/ChangePassword`, {
            login: data.login,
            code: data.code,
            password: data.newPassword,
            passwordRepeat: data.repeatPassword,
          })
          .then((resp) => {
            commit("passwordSucess", resp.data.success);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    nodeComplete({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/SetNodeAsComplete?nodeId=${id}`)
          .then((resp) => {
            commit("setNodeComplete", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getStatsTree({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}User/GetStatTree`)
          .then((resp) => {
            commit("stats", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
